"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var FieldReader_1 = require("../../core/conversions/FieldReader");

var Baseline_1 = require("../model/Baseline");

var BaselineConverter_1 = require("./BaselineConverter");
/**
 * @author Adam Drda
 */


var BaselineConverterImpl =
/*#__PURE__*/
function (_BaselineConverter_1$) {
  _inherits(BaselineConverterImpl, _BaselineConverter_1$);

  function BaselineConverterImpl() {
    var _this;

    _classCallCheck(this, BaselineConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BaselineConverterImpl).apply(this, arguments));
    _this.materializer = Baseline_1.Baseline.fromMat;
    _this.readers = {
      id: FieldReader_1.FieldReader.fromDocIdDesc(Baseline_1.Baseline.schema.id),
      externalId: FieldReader_1.FieldReader.fromDesc(Baseline_1.Baseline.schema.externalId),
      productId: FieldReader_1.FieldReader.fromIdDesc(Baseline_1.Baseline.schema.productId),
      siteId: FieldReader_1.FieldReader.fromIdDesc(Baseline_1.Baseline.schema.siteId),
      date: FieldReader_1.FieldReader.fromDateDesc(Baseline_1.Baseline.schema.date),
      amount: FieldReader_1.FieldReader.fromDesc(Baseline_1.Baseline.schema.amount),
      stateFlags: FieldReader_1.FieldReader.fromDesc(Baseline_1.Baseline.schema.stateFlags)
    };
    return _this;
  }

  _createClass(BaselineConverterImpl, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        externalId: source.externalId,
        productId: conversions.toDocumentReferenceId(source.productId),
        siteId: conversions.toDocumentReferenceId(source.siteId),
        date: conversions.fromDate(source.date),
        amount: source.amount,
        stateFlags: source.stateFlags.serialize()
      });
      return result;
    }
  }]);

  return BaselineConverterImpl;
}(BaselineConverter_1.BaselineConverter);

exports.BaselineConverterImpl = BaselineConverterImpl;